import DependencyInjector from '@atds-legacy/js-di';
import { LiveManager } from '@redge-media/fo-js-sdk';
import Info from '@/shared/libs/sdk/info';
import Time from '@/shared/libs/sdk/time';
import Subscriber from '@/shared/libs/sdk/subscriber/subscriber';
import Categories from '@/shared/libs/sdk/categories';
import Document from '@/shared/libs/sdk/document';
import Badges from '@/shared/libs/sdk/badges';
import Bookmarks from '@/shared/libs/sdk/bookmarks/bookmarks';
import Favourites from '@/shared/libs/sdk/bookmarks/favourites';
import Profiles from '@/shared/libs/sdk/subscriber/profiles';
import Avatars from '@/shared/libs/sdk/subscriber/avatars';
import ChannelsResourceClass from '@/shared/libs/sdk/live/channels';
import ProgramsResourceClass from '@/shared/libs/sdk/live/programs';

const services = new DependencyInjector();
services.register('info', () => new Info());
services.register('time', (info) => new Time(info), ['info']);
services.register('subscriber', (info, time) => new Subscriber(info, time), ['info', 'time']);
services.register('profiles', (subscriber) => new Profiles(subscriber), ['subscriber']);
services.register('avatars', (subscriber) => new Avatars(subscriber), ['subscriber']);
services.register('favourites', (subscriber, time) => new Favourites(subscriber, time), ['subscriber', 'time']);
services.register('badges', () => new Badges());
services.register('bookmarks', (subscriber, time, info) => new Bookmarks(subscriber, time, info), ['subscriber', 'time', 'info']);
services.register('translations', () => new Document('translations', { content: true }));
services.register('menu', () => new Document('menu', { content: true }));
services.register('search', () => new Document('search', { content: true }));
services.register('footer', () => new Document('footer', { content: true }));
services.register('agreementTenant', () => new Document('agreement-tenant', { content: true }));
services.register('embeddedPlayerBlacklist', () => new Document('embedded-player-blacklist', { content: true }));
services.register('categories', () => new Categories());
services.register('liveManager', () => LiveManager.create({
  format: 'YYYY-MM-DDTHH:mmZZ',
  ChannelsResourceClass,
  ProgramsResourceClass,
}));

export { services };

export default (ctx, inject) => {
  inject('services', services);
};
